export default __webpack_public_path__ + "static/media/ppl-title-texture.26f20e1d.svg";